/* eslint-disable */
import { useRef, useState } from "react";
import { Camera, Trash2 } from "lucide-react";
import { apiFetch } from "../auth/apiClient";
import { resolveAvatarUrl } from "../utils/avatarUrl";
import "./AvatarWidget.css";

export default function AvatarWidget({
  userId,
  currentUrl,
  name,
  onChanged,
  size = 96,
  editable = true,
}) {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [previewUrl, setPreviewUrl] = useState(null);

  const url = previewUrl || resolveAvatarUrl(currentUrl);
  const initials = (name || "?")
    .trim()
    .split(/\s+/)
    .map((s) => s[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    setError("");
    try {
      // Optimistic preview from the local blob.
      const blobUrl = URL.createObjectURL(file);
      setPreviewUrl(blobUrl);
      const fd = new FormData();
      fd.append("file", file);
      const path = userId ? `/api/users/${userId}/avatar` : "/api/users/me/avatar";
      const r = await apiFetch(path, {
        method: "POST",
        formData: fd,
        authRequired: true,
      });
      onChanged && onChanged(r.avatar_url);
    } catch (e) {
      setError(e.message || "Upload failed");
      setPreviewUrl(null);
    } finally {
      setBusy(false);
    }
  };

  const remove = async () => {
    if (!window.confirm("Remove your profile photo?")) return;
    setBusy(true);
    setError("");
    try {
      const path = userId ? `/api/users/${userId}/avatar` : "/api/users/me/avatar";
      await apiFetch(path, { method: "DELETE", authRequired: true });
      setPreviewUrl(null);
      onChanged && onChanged(null);
    } catch (e) {
      setError(e.message || "Could not remove");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="vsav-wrap">
      <div
        className="vsav-circle"
        style={{ width: size, height: size, fontSize: size * 0.36 }}
      >
        {url ? (
          <img src={url} alt={name || "avatar"} />
        ) : (
          <span>{initials}</span>
        )}
        {editable && (
          <button
            type="button"
            className="vsav-edit-btn"
            onClick={() => fileRef.current?.click()}
            disabled={busy}
            aria-label="Change photo"
          >
            <Camera size={14} strokeWidth={2.2} />
          </button>
        )}
        <input
          ref={fileRef}
          type="file"
          accept="image/jpeg,image/png,image/webp"
          hidden
          onChange={(e) => {
            const f = e.target.files?.[0];
            e.target.value = "";
            if (f) upload(f);
          }}
        />
      </div>
      {editable && url && (
        <button
          type="button"
          className="vsav-remove-btn"
          onClick={remove}
          disabled={busy}
        >
          <Trash2 size={11} /> Remove photo
        </button>
      )}
      {error && <div className="vsav-error">{error}</div>}
      {busy && <div className="vsav-busy">Working…</div>}
    </div>
  );
}
